/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetCollectiveInvestmentFundFiling = require('../services/GetCollectiveInvestmentFundFiling');
var GetAllCollectiveInvestmentFundFilingLookups = require('../services/GetAllCollectiveInvestmentFundFilingLookups');

var CollectiveInvestmentFundFiling = require('../forms/CollectiveInvestmentFundFiling');

module.exports = {
  event: 'build:filing:collective-investment-fund',

  channel: 'dp:filing',

  builder: function(config) {
    var defer = $.Deferred();
    var currFilingId = config.filingId;
    $.when(GetCollectiveInvestmentFundFiling(currFilingId), GetAllCollectiveInvestmentFundFilingLookups())
      .done(function(filingContent, lookups) {
        defer.resolve(
          new CollectiveInvestmentFundFiling({
            isReadOnly: config.isReadOnly,
            mode: config.mode || 'ext-new', // Possible values of mode: 'ext-new', 'int-new', 'resubmit', 'print', 'int-expand'
            model: new Backbone.Model({
              filingId: currFilingId,
              filingContent: filingContent,
              fundActions: lookups.fundActions,
              subFundActions: lookups.subFundActions
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
